/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import zip from 'lodash/zip';
import map from 'lodash/map';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import imgConnected from './images/connected.svg';
import imgDisconnected from './images/disconnected.svg';

const kAK = 'sKOR1iZ8dB2Ry3o7NjIQaBa0LGA40vY5';
const defaultProps = {
  onZoom: () => {},
  onDrag: () => {},
};

const propTypes = {
  gateways: React.PropTypes.array.isRequired,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  onZoom: React.PropTypes.func,
  onDrag: React.PropTypes.func,
};

class GatewayMap extends React.Component {

  static getCenterAndZoom(points) {
    let span = 0.0001;
    let center = points[0];
    points.forEach((x) => {
      if (center.lat !== x.lat || center.lng !== x.lng) {
        center = new BMap.Point(
          (center.lng + x.lng) / 2,
          (center.lat + x.lat) / 2,
        );
      }
      points.forEach((y) => {
        span = Math.max(span, Math.max(
          Math.abs(x.lat - y.lat),
          Math.abs(x.lng - y.lng),
        ));
      });
    });
    let zoom = 2;
    if (span < 0.001) {
      zoom = 16;
    } else if (span < 0.1) {
      zoom = 14;
    } else if (span < 0.5) {
      zoom = 11;
    } else if (span < 1) {
      zoom = 8;
    } else if (span < 10) {
      zoom = 6;
    } else if (span < 20) {
      zoom = 5;
    }
    return [center, zoom];
  }

  static getStatus(gw) {
    if (_.isNil(gw.lastOn)) {
      return false;
    }
    if (_.isNil(gw.lastOff)) {
      return true;
    }
    const onts = new Date(gw.lastOn).valueOf();
    const offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return true;
    }
    return false;
  }

  constructor(props) {
    super(props);
    this.markers = [];
    this.listeners = [];
    this.maxCount = 0;
    this.gateways = [];
    this.intlMsg = new IntlMsg(props.intl, 'gateway.map');
    this.transformBMapPoint = this.transformBMapPoint.bind(this);
  }

  componentDidMount() {
    let tries = 0;
    const init = () => {
      try {
        this.initMap();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  }

  componentWillReceiveProps(nextProps) {
    const { gateways } = nextProps;
    if (!_.isEqual(gateways, gateways)) {
      this.transform(gateways, this.transformBMapPoint);
      if (this.map) {
        this.map.clearOverlays();
      }
    }
  }

  componentWillUnmount() {
    map(zip(this.markers, this.listeners), ([marker, listener]) => {
      marker.removeEventListener('click', listener);
    });
    $('#gwmap').empty();
  }

  initMap() {
    this.map = new BMap.Map('gwmap');
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', () => this.props.onZoom(this.map));
    this.map.addEventListener('dragend', () => this.props.onDrag(this.map));
    if (this.map) {
      this.transform(this.props.gateways, this.transformBMapPoint);
    }
  }

  transform(gws, callback) {
    let temp = gws;
    const tobeTrans = [];
    let index = 0;
    temp = temp.filter((gw) => {
      const { lat = '', lng = '' } = gw;
      return lat !== '' && lng !== '' && lat !== 'undefined' && lng !== 'undefined';
    });
    const baiduGps = [];
    const gateways = [];
    _.forEach(temp, (g) => {
      if (g.gpssrc === 'auto') {
        gateways.push(g);
      } else {
        baiduGps.push(g);
      }
    });
    this.handleBaiduPoint(baiduGps);

    this.maxCount = Math.ceil(gateways.length / 100);
    if (gateways.length) {
      for (let i = 0; i < this.maxCount; i += 1) {
        const tt = gateways.slice(i * 100, (i + 1) * 100);
        tobeTrans.push(tt);
      }
      const loop = () => {
        if (index < this.maxCount) {
          const arr = tobeTrans[index];
          if (arr.length) {
            const coords = arr
              .map((gw) => {
                const { lng, lat } = gw;
                return `${lng},${lat}`;
              }).join(';');
            $.ajax({
              url: `https://api.map.baidu.com/geoconv/v1/?coords=${coords}&from=1&to=5&ak=${kAK}&callback=?`,
              dataType: 'jsonp',
              success(res) {
                callback(arr, res);
                index += 1;
                loop();
              },
            });
          }
        }
      };
      loop();
    } else if (this.map) {
      this.map.centerAndZoom('深圳', 1);
    }
  }

  handleBaiduPoint(gws) {
    const gateways = _.map(gws, g => ({
      ...g,
      point: new BMap.Point(g.lng, g.lat),
      status: GatewayMap.getStatus(g),
    }));
    this.updateData(gateways);
  }

  transformBMapPoint(arr, res) {
    const ps = res.result || [];
    const gateways = _.map(arr, (a, idx) => {
      if (ps[idx]) {
        return {
          ...a,
          point: new BMap.Point(ps[idx].x, ps[idx].y),
          status: GatewayMap.getStatus(a),
        };
      }
      return { ...a, status: GatewayMap.getStatus(a) };
    });
    this.updateData(gateways);
  }

  updateData(gateways) {
    gateways.forEach((obj) => {
      this.addMarker(obj);
    });

    const points = gateways.map(x => x.point);
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 20 points
      const [center, zoom] = GatewayMap.getCenterAndZoom(points.slice(0, 20));
      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  }

  info(obj) {
    const disconnected = (`
      <span style="color: #CF000F;">
        ${this.intlMsg.msg('status.disconnected')}
      </span>
    `);
    const connected = (`
      <span style="color: #00B16A;">
        ${this.intlMsg.msg('status.connected')}
      </span>
    `);

    const status = obj.status ? connected : disconnected;

    return (
`
<div>
  <h4 style="font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;">
    ${this.intlMsg.msg('id')}&nbsp;<a id="infowin">${obj.id}</a>
  </h4>
  <dl class="dl-horizontal" style="font-size: 12px; background-color: #eeeeee; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;">
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('mac')}
      </span>
      <span>${obj.mac}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('name')}
      </span>
      <span>${obj.name}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('address')}
      </span>
      <span>${obj.area} ${obj.address}</span>
    </div>
    <div style="padding: 5px 0;">
      <span style="width: 80px; display: inline-block; text-align: right; padding-right: 10px; font-weight: 700;">
        ${this.intlMsg.msg('status')}
      </span>
      <span>${status}</span>
    </div>
  </dl>
</div>
`
    );
  }

  addMarker(item) {
    const opts = {
      width: 400,
      height: 180,
      title: '',
      enableMessage: true,
    };

    const { pushState } = this.props;
    const that = this;
    const openInfo = () => {
      const info = that.info(item);
      const infoWin = new BMap.InfoWindow(info, opts);
      this.map.openInfoWindow(infoWin, item.point);
      setTimeout(() => {
        $('#infowin').click(() => pushState(`/gateway/detail/${item.id}`));
      }, 300);
    };

    const icon =
      item.status
      ? new BMap.Icon(imgConnected, new BMap.Size(25, 25))
      : new BMap.Icon(imgDisconnected, new BMap.Size(25, 25));
    const marker = new BMap.Marker(item.point, { icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  }

  render() {
    return <div id="gwmap" style={{ height: '100%', width: '100%' }} />;
  }
}

GatewayMap.defaultProps = defaultProps;
GatewayMap.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(GatewayMap));




// WEBPACK FOOTER //
// ./src/components/GatewayMap/index.jsx